import { Routes } from '@angular/router';

import { ListComponent } from './list/list.component';
import { DealerUsersComponent } from './dealer-users/dealer-users.component';

import { AuthGuard } from '../auth.guard';
import { RootComponent } from '../root/root.component';

export const routing: Routes = [
  {
    path: 'dealer',
    component: RootComponent, canActivate: [AuthGuard],

    children: [
      { path: '', component: ListComponent },
      { path: 'list', component: ListComponent },
      { path: ':dealerId/users', component: DealerUsersComponent }
    ]
  }
];
